<dialog qai-dialog #dialog [heading]="title()" (afterClose)="handleAfterClose()">
  <avatar-look-voice-selector
    #avatarVoiceSelector
    [form]="form()"
    [savingPersona]="isSavingPersona()"
    [simulationUuid]="callUuid()"
    [moduleUuid]="moduleUuid()"
    [isSelfAuthoring]="true"
    (avatarChange)="handleAvatarChange($event)"
  ></avatar-look-voice-selector>

  <div class="action-button-container">
    <button qai-button kind="secondary" size="medium" (click)="handleBackClick()">
      {{ 'simulationBuilder.BACK_TO_SIMULATION_DETAILS_BUTTON' | transloco }}
    </button>
    <button
      qai-button
      kind="primary"
      size="medium"
      [disabled]="!avatarVoiceSelector.selectedAvatar() || isLaunchingTestSimulation() || isSavingPersona()"
      (click)="handleTestSimulationClick()"
    >
      {{ 'simulationBuilder.TEST_SIMULATION_BUTTON' | transloco }}
    </button>
  </div>
</dialog>
